import { useCallback, useEffect, useState } from 'react'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { CurrenciesTab } from './CurrenciesTab'
import { GroupsTab } from './GroupsTab'
import { PaymentProvidersTab } from './PaymentProvidersTab'
import { Currency } from '../../../common/models'
import { useTableParams } from '../../../core/hooks/table-params'
import { getCurrencies } from '../../../core/services/festival-settings'
import { Card } from '@/components/ui'
import { Header, PageTitle } from '@/components'

type GroupType = 'fg' | 'cu' | 'pp'

export const GroupsPage: React.FC = (): JSX.Element => {
  const [key, setKey] = useState<GroupType>('fg')
  const { setExtraParams } = useTableParams({
    extraParams: {
      key: 'fg',
    },
    onlyExtraParams: true,
  })

  const [currencies, setCurrencies] = useState<Currency[]>([])

  const init = useCallback(async () => {
    try {
      const { status, data } = await getCurrencies()
      if (status === 200) {
        setCurrencies(data.currencies)
      }
    } catch (err) {
      console.log(err)
    }
  }, [])

  useEffect(() => {
    init()
  }, [init])

  return (
    <>
      <Header pageTitle="Groups" />
      <Tabs
        value={key}
        onValueChange={(value) => {
          setKey(value as GroupType)
          setExtraParams((s) => ({ ...s, key: value }))
        }}
      >
        <TabsList className="grid w-full mb-2">
          <div className="bg-white/10 p-2.5 rounded-[20px]">
            <TabsTrigger value="fg">Festival Groups</TabsTrigger>
            <TabsTrigger value="cu">Currencies</TabsTrigger>
            <TabsTrigger value="pp">Payment Providers</TabsTrigger>
          </div>
        </TabsList>
        <Card className="!bg-monochrome4-60 p-5 backdrop-blur-lg max-h-[calc(100vh-200px)] overflow-y-auto">
          <PageTitle title="Groups" subtitle="Groups Configuration" />
          <TabsContent value="fg">
            <GroupsTab currencies={currencies} />
          </TabsContent>
          <TabsContent value="cu">
            <CurrenciesTab />
          </TabsContent>
          <TabsContent value="pp">
            <PaymentProvidersTab />
          </TabsContent>
        </Card>
      </Tabs>
    </>
  )
}
